export const tools = {
  askQuestion: async () => {
    return prompt('Please enter your name')
  }
}
